import React from 'react';
import { Link } from 'react-router-dom';
import { DonateButton } from './DonateButton';
import { SubmitToolButton } from './SubmitToolButton';
import { AINewsNarrator } from './AINewsNarrator';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-40 border-b border-white/5 bg-black/50 backdrop-blur-xl" data-id="element-97">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-8" data-id="element-98">
        <Link to="/" className="text-xl font-bold text-white font-hero tracking-wider shrink-0" data-id="element-99">
          FAIND
        </Link>

        <div className="flex-1 flex justify-center" data-id="element-100">
          <div className="max-w-xl w-full" data-id="element-101">
            <AINewsNarrator data-id="element-102" />
          </div>
        </div>

        <div className="flex items-center gap-4 shrink-0" data-id="element-103">
          <SubmitToolButton data-id="element-104" />
          <DonateButton data-id="element-105" />
        </div>
      </div>
    </header>;
}